/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ClientProjectType = {
    ProjectProposal: 'PROJECT_PROPOSAL',
    CompletedProject: 'COMPLETED_PROJECT'
} as const;
export type ClientProjectType = typeof ClientProjectType[keyof typeof ClientProjectType];


export function instanceOfClientProjectType(value: any): boolean {
    for (const key in ClientProjectType) {
        if (Object.prototype.hasOwnProperty.call(ClientProjectType, key)) {
            // @ts-ignore
            if (ClientProjectType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ClientProjectTypeFromJSON(json: any): ClientProjectType {
    return ClientProjectTypeFromJSONTyped(json, false);
}

export function ClientProjectTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientProjectType {
    return json as ClientProjectType;
}

export function ClientProjectTypeToJSON(value?: ClientProjectType | null): any {
    return value as any;
}

